import pl from './pl'
import en from './en'

export default {
	pl,
	en
}



// WEBPACK FOOTER //
// ./src/i18n/index.js